import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import schoolService from '../../services/api/schoolService';
import { invoiceManagementAPI } from '../../services/api/urls';
import request from '../../services/request';
import { AdminHeader, Paging } from '../../components';
import { WelbeeTypes } from '../../utils/Constants';
import { Checkbox, IconButton, Stack, Dialog, DialogTitle, DialogContent, DialogActions, TextField, FormControl, FormControlLabel, InputLabel, Select, MenuItem, Button, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { AppContainer, BodyContainer, MainContentContainer } from '../../resources/styling/appStyle';
import { SideMenu } from '../../components/layouts/SideMenu';
import { Header } from '../../components/layouts/Header';
import SearchIcon from '@mui/icons-material/Search';
import RefreshIcon from '@mui/icons-material/Refresh';
import { toast } from 'react-toastify';
import { PaginationWrapper } from './SuperAdminStyle';
import { format, parseISO } from 'date-fns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import {
  sa,
  DataTable,
  Card,
  PillButton,
  SelectPill,
  SectionHeaderRow,
} from '../../components/superAdminUi';

// The Super Admin Invoices screen on the redesigned surface: a section header carrying the
// view toggle and bulk / refresh actions, filter and search cards, and the shared purple-header
// zebra DataTable. Presentation only — every service call, filter, search, selection, pagination
// and invoice action (issue / pay / partial / void / reverse / download / history) is preserved,
// as are the existing dialogs.

const Page = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sa.space.section};
  width: 100%;
  font-family: ${sa.font.family};
`;

const FilterBar = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`;

const SearchBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1 280px;
  min-width: 240px;
  background: ${sa.color.white};
  border: 1px solid ${sa.color.stroke};
  border-radius: ${sa.radius.sm};
  padding: 8px 12px;

  svg {
    color: ${sa.color.textGray};
    font-size: 20px;
  }
  input {
    flex: 1;
    border: none;
    outline: none;
    font-family: ${sa.font.family};
    font-size: 13px;
    color: ${sa.color.text};
    background: transparent;
  }
`;

const FilterField = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: ${sa.font.family};
  font-size: 13px;
  font-weight: ${sa.font.semibold};
  color: ${sa.color.textGray};
`;

const RowName = styled.span`
  font-weight: ${sa.font.semibold};
  color: ${sa.color.text};
`;

const StatusPill = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: ${sa.radius.chip};
  font-family: ${sa.font.family};
  font-weight: ${sa.font.semibold};
  font-size: 12px;
  line-height: 1;
  background: ${(p) => p.$bg};
  color: ${(p) => p.$fg};
`;

const ActionCell = styled.div`
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
`;

// Presentational status palette for the invoice pills, using brand tokens where they exist and
// soft success/warning fills to round out the set.
const statusTone = (status) => {
  if (status === 'Paid') return { bg: '#dff5ea', fg: '#1f9d6b' };
  if (status === 'Issued') return { bg: sa.color.schoolBg, fg: sa.color.blue };
  if (status === 'Voided' || status === 'Cancelled') return { bg: sa.color.groupBg, fg: sa.color.pink };
  if (status === 'Partially Paid') return { bg: '#fdecd2', fg: '#c77700' };
  return { bg: sa.color.mist, fg: sa.color.textGray };
};

const statusFilterOptions = [
  { value: 'All', label: 'All' },
  { value: 'New', label: 'New' },
  { value: 'Issued', label: 'Issued' },
  { value: 'Paid', label: 'Paid' },
  { value: 'Partially Paid', label: 'Partially Paid' },
  { value: 'Voided', label: 'Voided' },
  { value: 'Cancelled', label: 'Cancelled' },
];

class Invoices extends Component {
    constructor(props) {
        super(props);

        this.state = {
            pageOfItems: [],
            schoolsInvoiceList: [],
            filteredList: [],
            allInvoices: [], // US 6.1: All invoices (not just outstanding)
            selectTestAccount: false,
            nameSearchValue: '',
            isChanged: false,
            // US 6.1: Enhanced filtering
            filterStatus: 'All',
            filterFromDate: null,
            filterToDate: null,
            showAllInvoices: false, // Toggle between outstanding and all invoices
            selectedInvoices: [],
            // US 6.5: Payment history dialog
            paymentHistoryDialogOpen: false,
            selectedInvoiceForPayment: null,
            paymentHistory: [],
            // US 6.3, 6.4, 6.7, 6.8: Status change dialogs
            markIssuedDialogOpen: false,
            markPaidDialogOpen: false,
            partialPaymentDialogOpen: false,
            cancelInvoiceDialogOpen: false,
            reverseStatusDialogOpen: false,
            selectedInvoice: null,
        };
        this.computeDiscount = this.computeDiscount.bind(this);
        this.setDiscountText = this.setDiscountText.bind(this);
        this.setSelected = this.setSelected.bind(this);
        this.setSendInvoiceCheck = this.setSendInvoiceCheck.bind(this);
        this.sendInvoices = this.sendInvoices.bind(this);
        this.applyFilters = this.applyFilters.bind(this);
        this.handleNameSearchChange = this.handleNameSearchChange.bind(this);
        this.onChangePage = this.onChangePage.bind(this);
        this.ReplacementEmail = this.ReplacementEmail.bind(this);
        this.getColumnText = this.getColumnText.bind(this);
        this.voidInvoice = this.voidInvoice.bind(this); // User Story 2
    }

    componentDidMount() {
        this.getAllOutstandingInvoices();
    }
    onChangePage(pageOfItems) {
        this.setState({ pageOfItems: pageOfItems });
    }
    getAllOutstandingInvoices() {
        schoolService
            .GetOutstandingInvoices()
            .then((response) => {
                if (response.data != null) {
                    this.setState({
                        schoolsInvoiceList: response.data
                    }, this.applyFilters);
                }
            });
    }
    
    // US 6.1: Get all invoices with filtering
    getAllInvoices = async () => {
        try {
            const params = new URLSearchParams();
            if (this.state.filterStatus !== 'All') params.append('status', this.state.filterStatus);
            if (this.state.filterFromDate) params.append('fromDate', this.state.filterFromDate.toISOString());
            if (this.state.filterToDate) params.append('toDate', this.state.filterToDate.toISOString());
            
            const response = await request({
                url: invoiceManagementAPI.GetAllInvoices(null, null, this.state.filterStatus, this.state.filterFromDate, this.state.filterToDate),
                method: 'GET',
            });
            
            if (response.success && response.data) {
                this.setState({
                    allInvoices: response.data,
                    schoolsInvoiceList: response.data,
                    showAllInvoices: true
                }, this.applyFilters);
            }
        } catch (error) {
            console.error('Error getting all invoices:', error);
            toast.error('Failed to load invoices');
        }
    }
    
    // US 6.3: Mark invoice as Issued
    markInvoiceAsIssued = async (invoiceId, issueDate) => {
        try {
            const response = await request({
                url: invoiceManagementAPI.MarkInvoiceAsIssued(invoiceId),
                method: 'PUT',
                data: { IssueDate: issueDate || new Date() }
            });
            
            if (response.success) {
                toast.success('Invoice marked as Issued successfully');
                this.setState({ markIssuedDialogOpen: false, selectedInvoice: null });
                this.refreshInvoices();
            } else {
                toast.error(response.message || 'Failed to mark invoice as Issued');
            }
        } catch (error) {
            console.error('Error marking invoice as issued:', error);
            toast.error('Error marking invoice as Issued');
        }
    }
    
    // US 6.4: Mark invoice as Paid
    markInvoiceAsPaid = async (invoiceId, paymentAmount, paymentDate, paymentReference) => {
        try {
            const response = await request({
                url: invoiceManagementAPI.MarkInvoiceAsPaid(invoiceId),
                method: 'PUT',
                data: {
                    PaymentAmount: paymentAmount,
                    PaymentDate: paymentDate || new Date(),
                    PaymentReference: paymentReference
                }
            });
            
            if (response.success) {
                toast.success('Invoice marked as Paid. Customer marked as renewed if applicable.');
                this.setState({ markPaidDialogOpen: false, selectedInvoice: null });
                this.refreshInvoices();
            } else {
                toast.error(response.message || 'Failed to mark invoice as Paid');
            }
        } catch (error) {
            console.error('Error marking invoice as paid:', error);
            toast.error('Error marking invoice as Paid');
        }
    }
    
    // US 6.5: Record partial payment
    recordPartialPayment = async (invoiceId, paymentAmount, paymentDate, paymentReference, paymentNotes) => {
        try {
            const response = await request({
                url: invoiceManagementAPI.RecordPartialPayment(invoiceId),
                method: 'POST',
                data: {
                    PaymentAmount: paymentAmount,
                    PaymentDate: paymentDate || new Date(),
                    PaymentReference: paymentReference,
                    PaymentNotes: paymentNotes
                }
            });
            
            if (response.success) {
                toast.success('Partial payment recorded successfully');
                this.setState({ partialPaymentDialogOpen: false, selectedInvoice: null });
                this.refreshInvoices();
                if (this.state.selectedInvoiceForPayment?.Id === invoiceId) {
                    this.loadPaymentHistory(invoiceId);
                }
            } else {
                toast.error(response.message || 'Failed to record partial payment');
            }
        } catch (error) {
            console.error('Error recording partial payment:', error);
            toast.error('Error recording partial payment');
        }
    }
    
    // US 6.5: Load payment history
    loadPaymentHistory = async (invoiceId) => {
        try {
            const response = await request({
                url: invoiceManagementAPI.GetInvoicePaymentHistory(invoiceId),
                method: 'GET'
            });
            
            if (response.success && response.data) {
                this.setState({ paymentHistory: response.data });
            }
        } catch (error) {
            console.error('Error loading payment history:', error);
        }
    }
    
    // US 6.7: Cancel invoice
    cancelInvoice = async (invoiceId, cancellationReason) => {
        try {
            const response = await request({
                url: invoiceManagementAPI.CancelInvoice(invoiceId),
                method: 'PUT',
                data: { CancellationReason: cancellationReason }
            });
            
            if (response.success) {
                toast.success('Invoice cancelled successfully');
                this.setState({ cancelInvoiceDialogOpen: false, selectedInvoice: null });
                this.refreshInvoices();
            } else {
                toast.error(response.message || 'Failed to cancel invoice');
            }
        } catch (error) {
            console.error('Error cancelling invoice:', error);
            toast.error('Error cancelling invoice');
        }
    }
    
    // US 6.8: Reverse invoice status
    reverseInvoiceStatus = async (invoiceId, newStatus, reason) => {
        try {
            const response = await request({
                url: invoiceManagementAPI.ReverseInvoiceStatus(invoiceId),
                method: 'PUT',
                data: { NewStatus: newStatus, Reason: reason }
            });
            
            if (response.success) {
                toast.success(`Invoice status reversed to ${newStatus}`);
                this.setState({ reverseStatusDialogOpen: false, selectedInvoice: null });
                this.refreshInvoices();
            } else {
                toast.error(response.message || 'Failed to reverse invoice status');
            }
        } catch (error) {
            console.error('Error reversing invoice status:', error);
            toast.error('Error reversing invoice status');
        }
    }
    
    // US 6.2: Download invoice PDF
    downloadInvoicePdf = async (invoiceId) => {
        try {
            // Note: No Authorization header needed - endpoint has [AllowAnonymous]
            const response = await fetch(invoiceManagementAPI.DownloadInvoicePdf(invoiceId), {
                method: 'GET'
            });
            
            if (response.ok) {
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `Invoice_${invoiceId}.pdf`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
                toast.success('Invoice downloaded successfully');
            } else {
                toast.error('Failed to download invoice');
            }
        } catch (error) {
            console.error('Error downloading invoice:', error);
            toast.error('Error downloading invoice');
        }
    }
    
    // US 6.10: Bulk invoice actions
    bulkInvoiceActions = async (action, invoiceIds) => {
        try {
            const requestData = {
                InvoiceIds: invoiceIds,
                Action: action,
                IssueDate: action === 'MarkAsIssued' ? new Date() : null,
                PaymentDate: action === 'MarkAsPaid' ? new Date() : null
            };
            
            const response = await request({
                url: invoiceManagementAPI.BulkInvoiceActions(),
                method: 'POST',
                data: requestData
            });
            
            if (response.success) {
                toast.success(response.message || `Bulk action completed`);
                this.setState({ selectedInvoices: [] });
                this.refreshInvoices();
            } else {
                toast.error(response.message || 'Bulk action failed');
            }
        } catch (error) {
            console.error('Error performing bulk action:', error);
            toast.error('Error performing bulk action');
        }
    }
    
    refreshInvoices = () => {
        if (this.state.showAllInvoices) {
            this.getAllInvoices();
        } else {
            this.getAllOutstandingInvoices();
        }
    }
    sendInvoices() {
        if (this.state.schoolsInvoiceList.length > 0) {
            schoolService
                .SendInvoices(this.state.filteredList.filter(x => x.IsSelected))
                .then((response) => {
                    if (response.success) {
                        toast.success('Invoice email(s) sent.');
                        this.getAllOutstandingInvoices();
                    }
                    else toast.error(response.message);
                })
                .catch((error) =>
                    console.log('error', error));
        }
        else
            toast.error("No invoices found");
    }
    setSendInvoiceCheck(val, item) {
        let newArr = this.state.filteredList;
        let i = newArr.findIndex(x => x.Id === item.Id);
        newArr[i].SuppressEmail = val;
        this.setState({ schoolsInvoiceList: newArr });
    }
    setSelected(val, item, selectAll) {
        let newArr = this.state.filteredList;
        if (selectAll) {
            newArr.forEach(item => item.IsSelected = val);
        }
        else {
            newArr[newArr.findIndex(x => x.Id === item.Id)].IsSelected = val;
        }
        this.setState({ filteredList: newArr });
    }
    setDiscountText(val, item) {
        let newArr = this.state.filteredList;
        newArr[newArr.findIndex(x => x.Id === item.Id)].DiscountText = val;
        this.setState({ filteredList: newArr });
    }
    ReplacementEmail(val, item) {
        let newArr = this.state.filteredList;
        newArr[newArr.findIndex(x => x.Id === item.Id)].ReplacementEmail = val;
        this.setState({ filteredList: newArr });
    }
    getColumnText(item) {
        let colText = '';
            if (item.IsUpgradeRequest) {
                let oldSubs = item.UpgradeFrom == WelbeeTypes.WelbeeVoiceFree ? 'Voice Free' :
                    item.UpgradeFrom == WelbeeTypes.WelbeeVoicePro ? 'Voice Pro' :
                        item.UpgradeFrom == WelbeeTypes.WelbeeSurveyFree ? 'Survey Free' :
                            item.UpgradeFrom == WelbeeTypes.WelbeeSurveyPro ? 'Survey Pro' : 'Survey Premium';
                let newSubs = item.UpgradeTo == WelbeeTypes.WelbeeVoicePro ? 'Voice Pro' :
                    item.UpgradeTo == WelbeeTypes.WelbeeSurveyPro ? 'Survey Pro' : 'Survey Premium';
                colText = oldSubs + ' - ' + newSubs;
            }
            else {
                // Note: SubscriptionId not available in optimized DTO, using InvoiceType as fallback
                colText = item.InvoiceType === WelbeeTypes.WelbeeVoicePro ? 'Voice Pro' :
                    item.InvoiceType === WelbeeTypes.WelbeeSurveyPro ? 'Survey Pro' : 'Survey Premium';
            }
        return colText;
    }
    // User Story 2: Void invoice
    voidInvoice(invoiceId) {
        if (window.confirm('Are you sure you want to void this invoice? This action cannot be undone.')) {
            schoolService.VoidInvoice(invoiceId, 'Admin')
                .then((response) => {
                    if (response.success) {
                        toast.success('Invoice voided successfully');
                        this.getAllOutstandingInvoices();
                    } else {
                        toast.error(response.message || 'Failed to void invoice');
                    }
                })
                .catch((error) => {
                    console.error('Error voiding invoice:', error);
                    toast.error('Error voiding invoice');
                });
        }
    }
    computeDiscount(val, item, type) {
        if (this.state.filteredList.length > 0) {
            let newArr = this.state.filteredList;
            let rowIndex = newArr.findIndex(x => x.Id === item.Id);
            let rowData = newArr[rowIndex]
            let percentageValue = 0;
            let value = 0;
            // Note: Using TotalAmount from DTO instead of calculating from School properties
            let total = rowData.TotalAmount || 0;
            if (type === 'p') {
                value = total - (val / 100) * total;
                percentageValue = val;
            }
            if (type === 'v') {
                percentageValue = (100 - ((val / total) * 100)).toFixed(2);
                value = val;
            }
            newArr[rowIndex].DiscountPercentage = percentageValue;
            newArr[rowIndex].DiscountAmount = value;
            this.setState({ filteredList: newArr });
        }
    }
    applyFilters() {
        const {
            nameSearchValue,
            schoolsInvoiceList,
            selectTestAccount
        } = this.state;
        // Updated to use CustomerName from optimized DTO instead of School.Name
        let searchList = schoolsInvoiceList.filter(x => {
            const customerName = (x.CustomerName || '').toLocaleLowerCase();
            const searchTerm = nameSearchValue.toLocaleLowerCase();
            return customerName.includes(searchTerm);
            // Note: IsTestAccount filter removed as it's not in the optimized DTO
        });
        this.setState({ filteredList: searchList });
    }
    handleNameSearchChange = (e) => {
        this.setState({ nameSearchValue: e.target.value }, this.applyFilters);
    }
    // Column set for the shared DataTable — the same selection, status and action wiring as the
    // previous hand-rolled table, expressed declaratively.
    getInvoiceColumns() {
        const { pageOfItems } = this.state;
        const allSelected = pageOfItems.length > 0 && pageOfItems.every((x) => x.IsSelected);

        return [
            {
                key: 'select',
                width: '5%',
                align: 'center',
                header: (
                    <Checkbox
                        size='small'
                        sx={{ p: 0, color: sa.color.white, '&.Mui-checked': { color: sa.color.white } }}
                        checked={allSelected}
                        onChange={(e) => this.setSelected(e.target.checked, 0, true)}
                    />
                ),
                render: (item, i) => (
                    <Checkbox
                        size='small'
                        sx={{ p: 0, color: sa.color.teal, '&.Mui-checked': { color: sa.color.teal } }}
                        checked={!!this.state.pageOfItems[i].IsSelected}
                        onChange={(e) => {
                            const selected = this.state.selectedInvoices;
                            if (e.target.checked) {
                                if (!selected.includes(item.Id)) selected.push(item.Id);
                            } else {
                                const index = selected.indexOf(item.Id);
                                if (index > -1) selected.splice(index, 1);
                            }
                            this.setState({ selectedInvoices: selected });
                            this.setSelected(e.target.checked, item, false);
                        }}
                    />
                ),
            },
            {
                key: 'invoiceNumber',
                header: 'Invoice #',
                width: '11%',
                render: (item) => item.InvoiceNumber || `INV-${item.Id}`,
            },
            {
                key: 'customer',
                header: 'Customer',
                width: '15%',
                render: (item) => <RowName>{item.CustomerName || 'Not Provided'}</RowName>,
            },
            {
                key: 'orderDate',
                header: 'Order Date',
                //width: '10%',
                render: (item) =>
                    item.OrderDate ? format(parseISO(item.OrderDate), 'MMM dd, yyyy') : 'Not Provided',
            },
            {
                key: 'status',
                header: 'Status',
                //width: '6%',
                render: (item) => {
                    const invoiceStatus = item.InvoiceStatus || (item.InvoiceSent ? 'Issued' : 'New');
                    const tone = statusTone(invoiceStatus);
                    return (
                        <StatusPill $bg={tone.bg} $fg={tone.fg}>
                            {invoiceStatus}
                        </StatusPill>
                    );
                },
            },
            {
                key: 'total',
                header: 'Total',
                //width: '10%',
                render: (item) => `£${item.TotalAmount?.toFixed(2) || '0.00'}`,
            },
            {
                key: 'remaining',
                header: 'Remaining',
                //width: '10%',
                render: (item) =>
                    `£${item.RemainingBalance?.toFixed(2) || item.TotalAmount?.toFixed(2) || '0.00'}`,
            },
            {
                key: 'issueDate',
                header: 'Issue Date',
                //width: '10%',
                render: (item) =>
                    item.IssueDate ? format(parseISO(item.IssueDate), 'MMM dd, yyyy') : '-',
            },
            {
                key: 'paymentDate',
                header: 'Payment Date',
                //width: '10%',
                render: (item) =>
                    item.PaymentDate ? format(parseISO(item.PaymentDate), 'MMM dd, yyyy') : '-',
            },
            {
                key: 'actions',
                header: 'Actions',
                width: '15%',
                cellStyle: { whiteSpace: 'normal' },
                render: (item) => {
                    const invoiceStatus = item.InvoiceStatus || (item.InvoiceSent ? 'Issued' : 'New');
                    return (
                        <ActionCell>
                            {invoiceStatus === 'New' && (
                                <PillButton
                                    type='button'
                                    $variant='danger'
                                    onClick={() => this.setState({ selectedInvoice: item, markIssuedDialogOpen: true })}
                                >
                                    Mark Issued
                                </PillButton>
                            )}
                            {(invoiceStatus === 'New' || invoiceStatus === 'Issued' || invoiceStatus === 'Partially Paid') && (
                                <>
                                    <PillButton
                                        type='button'
                                        $variant='blue'
                                        onClick={() => this.setState({ selectedInvoice: item, markPaidDialogOpen: true })}
                                    >
                                        Mark Paid
                                    </PillButton>
                                    {invoiceStatus !== 'Paid' && (
                                        <PillButton
                                            type='button'                                            
                                            $variant='purple'
                                            onClick={() => this.setState({ selectedInvoice: item, partialPaymentDialogOpen: true })}
                                        >
                                            Partial Payment
                                        </PillButton>
                                    )}
                                </>
                            )}
                            {(invoiceStatus === 'New' || invoiceStatus === 'Sent' || invoiceStatus === 'Issued') && (
                                <PillButton
                                    type='button'
                                    $variant='danger'
                                    onClick={() => this.voidInvoice(item.Id)}
                                >
                                    Void
                                </PillButton>
                            )}
                            <PillButton
                                type='button'                                    
                                $variant='orange'
                                onClick={() => this.downloadInvoicePdf(item.Id)}
                            >
                                Download
                            </PillButton>
                            {invoiceStatus === 'Paid' && (

                                <PillButton
                                    type='button'                                    
                                    $variant='mist'
                                    onClick={() => {
                                        this.setState({
                                            selectedInvoice: item,
                                            reverseStatusDialogOpen: true,
                                        });
                                    }}
                                >
                                    Reverse Status
                                </PillButton>
                                // <IconButton
                                //     size='small'
                                //     onClick={() => {
                                //         this.setState({
                                //             selectedInvoice: item,
                                //             reverseStatusDialogOpen: true,
                                //         });
                                //     }}
                                // >
                                //     <RefreshIcon fontSize='small' />
                                // </IconButton>
                            )}

                            <PillButton
                                type='button'                                    
                                $variant='green'
                                onClick={() => {
                                    this.setState({
                                        selectedInvoiceForPayment: item,
                                        paymentHistoryDialogOpen: true,
                                    });
                                    this.loadPaymentHistory(item.Id);
                                }}
                            >
                                History
                            </PillButton>
                        </ActionCell>
                    );
                },
            },
        ];
    }
    render() {
        return (
            <AppContainer>
                <SideMenu />
                <BodyContainer>
                    <Header />
                    <AdminHeader />
                    <MainContentContainer>
                        <Page>
                            <SectionHeaderRow
                                title={this.state.showAllInvoices ? 'All Invoices' : 'Outstanding Invoices'}
                                size='lg'
                            >
                                <PillButton
                                    type='button'
                                    onClick={() => this.setState({ showAllInvoices: !this.state.showAllInvoices }, () => this.refreshInvoices())}
                                >
                                    {this.state.showAllInvoices ? 'Show Outstanding Only' : 'Show All Invoices'}
                                </PillButton>
                                {this.state.selectedInvoices.length > 0 && (
                                    <>
                                        <PillButton
                                            type='button'
                                            onClick={() => this.bulkInvoiceActions('MarkAsIssued', this.state.selectedInvoices)}
                                        >
                                            Bulk Mark as Issued ({this.state.selectedInvoices.length})
                                        </PillButton>
                                        <PillButton
                                            type='button'
                                            onClick={() => this.bulkInvoiceActions('MarkAsPaid', this.state.selectedInvoices)}
                                        >
                                            Bulk Mark as Paid ({this.state.selectedInvoices.length})
                                        </PillButton>
                                        <PillButton
                                            type='button'
                                            $variant='outline'
                                            onClick={() => {
                                                this.state.selectedInvoices.forEach(id => {
                                                    setTimeout(() => this.downloadInvoicePdf(id), 500);
                                                });
                                            }}
                                        >
                                            Bulk Download ({this.state.selectedInvoices.length})
                                        </PillButton>
                                    </>
                                )}
                                <PillButton type='button' onClick={this.refreshInvoices}>
                                    <RefreshIcon fontSize='small' /> Refresh
                                </PillButton>
                            </SectionHeaderRow>

                            {this.state.showAllInvoices && (
                                <Card $pad='16px'>
                                    <FilterBar>
                                        <FilterField>
                                            Status
                                            <SelectPill
                                                value={this.state.filterStatus}
                                                onChange={(value) => this.setState({ filterStatus: value }, () => this.getAllInvoices())}
                                                options={statusFilterOptions}
                                                ariaLabel='Filter by status'
                                                size='sm'
                                            />
                                        </FilterField>
                                        <FilterField>
                                            From
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DatePicker
                                                    label='From Date'
                                                    value={this.state.filterFromDate}
                                                    onChange={(date) => this.setState({ filterFromDate: date }, () => this.getAllInvoices())}
                                                    renderInput={(params) => <TextField {...params} size='small' />}
                                                />
                                            </LocalizationProvider>
                                        </FilterField>
                                        <FilterField>
                                            To
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DatePicker
                                                    label='To Date'
                                                    value={this.state.filterToDate}
                                                    onChange={(date) => this.setState({ filterToDate: date }, () => this.getAllInvoices())}
                                                    renderInput={(params) => <TextField {...params} size='small' />}
                                                />
                                            </LocalizationProvider>
                                        </FilterField>
                                        <PillButton
                                            type='button'
                                            $variant='outline'
                                            onClick={() => {
                                                this.setState({ filterStatus: 'All', filterFromDate: null, filterToDate: null }, () => this.getAllInvoices());
                                            }}
                                        >
                                            Clear Filters
                                        </PillButton>
                                    </FilterBar>
                                </Card>
                            )}

                            <Card $pad='16px'>
                                <FilterBar>
                                    <SearchBox>
                                        <SearchIcon />
                                        <input
                                            id='searchInputField'
                                            placeholder='Enter keyword'
                                            aria-label='Search invoices'
                                            onChange={(e) => {
                                                e.preventDefault();
                                                this.handleNameSearchChange(e);
                                            }}
                                        />
                                    </SearchBox>
                                    <FilterField>
                                        <Checkbox
                                            size='small'
                                            sx={{ p: 0, color: sa.color.teal, '&.Mui-checked': { color: sa.color.teal } }}
                                            id='selectTestAccountCheckbox'
                                            checked={this.state.selectTestAccount}
                                            onChange={(e) => this.setState({ selectTestAccount: e.target.checked }, this.applyFilters)}
                                        />
                                        Test Accounts
                                    </FilterField>
                                    <div className="ml-auto">
                                        <PillButton type='button' onClick={this.sendInvoices}>
                                            Send Invoices
                                        </PillButton>
                                    </div>
                                </FilterBar>
                            </Card>

                            <div>
                                <DataTable
                                    columns={this.getInvoiceColumns()}
                                    rows={this.state.pageOfItems}
                                    getRowKey={(item) => item.Id}
                                    empty='No invoices found'
                                />
                                <PaginationWrapper>
                                    <Paging
                                        items={this.state.filteredList}
                                        onChangePage={this.onChangePage}
                                        isChanged={this.state.isChanged}
                                    />
                                </PaginationWrapper>
                            </div>
                        </Page>

                        {/* US 6.3: Mark as Issued Dialog */}
                        <Dialog open={this.state.markIssuedDialogOpen} onClose={() => this.setState({ markIssuedDialogOpen: false, selectedInvoice: null })}>
                            <DialogTitle>Mark Invoice as Issued</DialogTitle>
                            <DialogContent>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DatePicker
                                        label="Issue Date"
                                        value={new Date()}
                                        onChange={(date) => this.setState({ issueDate: date })}
                                        renderInput={(params) => <TextField {...params} fullWidth sx={{ mt: 2 }} />}
                                    />
                                </LocalizationProvider>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => this.setState({ markIssuedDialogOpen: false, selectedInvoice: null })}>Cancel</Button>
                                <Button onClick={() => this.markInvoiceAsIssued(this.state.selectedInvoice?.Id, this.state.issueDate)} variant="contained">Mark as Issued</Button>
                            </DialogActions>
                        </Dialog>

                        {/* US 6.4: Mark as Paid Dialog */}
                        <Dialog open={this.state.markPaidDialogOpen} onClose={() => this.setState({ markPaidDialogOpen: false, selectedInvoice: null, paymentMethod: 'Invoice' })}>
                            <DialogTitle>Mark Invoice as Paid</DialogTitle>
                            <DialogContent>
                                <TextField
                                    fullWidth
                                    label="Payment Amount"
                                    type="number"
                                    defaultValue={this.state.selectedInvoice?.TotalAmount || 0}
                                    sx={{ mt: 2 }}
                                    inputRef={ref => this.paymentAmountInput = ref}
                                />
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DatePicker
                                        label="Payment Date"
                                        value={new Date()}
                                        onChange={(date) => this.setState({ paymentDate: date })}
                                        renderInput={(params) => <TextField {...params} fullWidth sx={{ mt: 2 }} />}
                                    />
                                </LocalizationProvider>
                                <FormControl component="fieldset" sx={{ mt: 2 }}>
                                    <Typography variant="subtitle2" sx={{ mb: 1 }}>Payment Method</Typography>
                                    <Stack direction="row" spacing={2}>
                                        <FormControlLabel
                                            control={
                                                <input
                                                    type="radio"
                                                    name="paymentMethod"
                                                    value="Invoice"
                                                    checked={this.state.paymentMethod === 'Invoice' || !this.state.paymentMethod}
                                                    onChange={(e) => this.setState({ paymentMethod: e.target.value })}
                                                    className="mr-8"
                                                />
                                            }
                                            label="Invoice"
                                        />
                                        <FormControlLabel
                                            control={
                                                <input
                                                    type="radio"
                                                    name="paymentMethod"
                                                    value="CardPay"
                                                    checked={this.state.paymentMethod === 'CardPay'}
                                                    onChange={(e) => this.setState({ paymentMethod: e.target.value })}
                                                    className="mr-8"
                                                />
                                            }
                                            label="Card Payment"
                                        />
                                        <FormControlLabel
                                            control={
                                                <input
                                                    type="radio"
                                                    name="paymentMethod"
                                                    value="BankTransfer"
                                                    checked={this.state.paymentMethod === 'BankTransfer'}
                                                    onChange={(e) => this.setState({ paymentMethod: e.target.value })}
                                                    className="mr-8"
                                                />
                                            }
                                            label="Bank Transfer"
                                        />
                                    </Stack>
                                </FormControl>
                                <TextField
                                    fullWidth
                                    label="Payment Reference (Optional)"
                                    sx={{ mt: 2 }}
                                    inputRef={ref => this.paymentReferenceInput = ref}
                                />
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => this.setState({ markPaidDialogOpen: false, selectedInvoice: null, paymentMethod: 'Invoice' })}>Cancel</Button>
                                <Button onClick={() => this.markInvoiceAsPaid(
                                    this.state.selectedInvoice?.Id,
                                    parseFloat(this.paymentAmountInput?.value || this.state.selectedInvoice?.TotalAmount || 0),
                                    this.state.paymentDate,
                                    this.paymentReferenceInput?.value || this.state.paymentMethod || 'Invoice'
                                )} variant="contained">Mark as Paid</Button>
                            </DialogActions>
                        </Dialog>

                        {/* US 6.5: Partial Payment Dialog */}
                        <Dialog open={this.state.partialPaymentDialogOpen} onClose={() => this.setState({ partialPaymentDialogOpen: false, selectedInvoice: null, partialPaymentMethod: 'Invoice' })}>
                            <DialogTitle>Record Partial Payment</DialogTitle>
                            <DialogContent>
                                <Typography variant="body2" sx={{ mb: 2 }}>
                                    Total Amount: £{this.state.selectedInvoice?.TotalAmount?.toFixed(2) || '0.00'}<br/>
                                    Remaining Balance: £{this.state.selectedInvoice?.RemainingBalance?.toFixed(2) || this.state.selectedInvoice?.TotalAmount?.toFixed(2) || '0.00'}
                                </Typography>
                                <TextField
                                    fullWidth
                                    label="Payment Amount"
                                    type="number"
                                    sx={{ mt: 2 }}
                                    inputRef={ref => this.partialPaymentAmountInput = ref}
                                />
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DatePicker
                                        label="Payment Date"
                                        value={new Date()}
                                        onChange={(date) => this.setState({ partialPaymentDate: date })}
                                        renderInput={(params) => <TextField {...params} fullWidth sx={{ mt: 2 }} />}
                                    />
                                </LocalizationProvider>
                                <FormControl component="fieldset" sx={{ mt: 2 }}>
                                    <Typography variant="subtitle2" sx={{ mb: 1 }}>Payment Method</Typography>
                                    <Stack direction="row" spacing={2}>
                                        <FormControlLabel
                                            control={
                                                <input
                                                    type="radio"
                                                    name="partialPaymentMethod"
                                                    value="Invoice"
                                                    checked={this.state.partialPaymentMethod === 'Invoice' || !this.state.partialPaymentMethod}
                                                    onChange={(e) => this.setState({ partialPaymentMethod: e.target.value })}
                                                    className="mr-8"
                                                />
                                            }
                                            label="Invoice"
                                        />
                                        <FormControlLabel
                                            control={
                                                <input
                                                    type="radio"
                                                    name="partialPaymentMethod"
                                                    value="CardPay"
                                                    checked={this.state.partialPaymentMethod === 'CardPay'}
                                                    onChange={(e) => this.setState({ partialPaymentMethod: e.target.value })}
                                                    className="mr-8"
                                                />
                                            }
                                            label="Card Payment"
                                        />
                                        <FormControlLabel
                                            control={
                                                <input
                                                    type="radio"
                                                    name="partialPaymentMethod"
                                                    value="BankTransfer"
                                                    checked={this.state.partialPaymentMethod === 'BankTransfer'}
                                                    onChange={(e) => this.setState({ partialPaymentMethod: e.target.value })}
                                                    className="mr-8"
                                                />
                                            }
                                            label="Bank Transfer"
                                        />
                                    </Stack>
                                </FormControl>
                                <TextField
                                    fullWidth
                                    label="Payment Reference (Optional)"
                                    sx={{ mt: 2 }}
                                    inputRef={ref => this.partialPaymentReferenceInput = ref}
                                />
                                <TextField
                                    fullWidth
                                    multiline
                                    rows={3}
                                    label="Payment Notes (Optional)"
                                    sx={{ mt: 2 }}
                                    inputRef={ref => this.partialPaymentNotesInput = ref}
                                />
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => this.setState({ partialPaymentDialogOpen: false, selectedInvoice: null, partialPaymentMethod: 'Invoice' })}>Cancel</Button>
                                <Button onClick={() => this.recordPartialPayment(
                                    this.state.selectedInvoice?.Id,
                                    parseFloat(this.partialPaymentAmountInput?.value || 0),
                                    this.state.partialPaymentDate || new Date(),
                                    this.partialPaymentReferenceInput?.value || this.state.partialPaymentMethod || 'Invoice',
                                    this.partialPaymentNotesInput?.value
                                )} variant="contained">Record Payment</Button>
                            </DialogActions>
                        </Dialog>

                        {/* US 6.5: Payment History Dialog */}
                        <Dialog open={this.state.paymentHistoryDialogOpen} onClose={() => this.setState({ paymentHistoryDialogOpen: false, selectedInvoiceForPayment: null, paymentHistory: [] })} maxWidth="md" fullWidth>
                            <DialogTitle>Payment History - Invoice #{this.state.selectedInvoiceForPayment?.InvoiceNumber || this.state.selectedInvoiceForPayment?.Id}</DialogTitle>
                            <DialogContent>
                                <TableContainer>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell><strong>Date</strong></TableCell>
                                                <TableCell><strong>Amount</strong></TableCell>
                                                <TableCell><strong>Reference</strong></TableCell>
                                                <TableCell><strong>Notes</strong></TableCell>
                                                <TableCell><strong>Recorded By</strong></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {this.state.paymentHistory.length === 0 ? (
                                                <TableRow>
                                                    <TableCell colSpan={5} align="center">No payment history</TableCell>
                                                </TableRow>
                                            ) : (
                                                this.state.paymentHistory.map((payment) => (
                                                    <TableRow key={payment.Id}>
                                                        <TableCell>{format(parseISO(payment.PaymentDate), 'MMM dd, yyyy')}</TableCell>
                                                        <TableCell>£{payment.PaymentAmount?.toFixed(2)}</TableCell>
                                                        <TableCell>{payment.PaymentReference || '-'}</TableCell>
                                                        <TableCell>{payment.PaymentNotes || '-'}</TableCell>
                                                        <TableCell>{payment.RecordedBy || '-'}</TableCell>
                                                    </TableRow>
                                                ))
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => this.setState({ paymentHistoryDialogOpen: false, selectedInvoiceForPayment: null, paymentHistory: [] })}>Close</Button>
                            </DialogActions>
                        </Dialog>

                        {/* US 6.7: Cancel Invoice Dialog */}
                        <Dialog open={this.state.cancelInvoiceDialogOpen} onClose={() => this.setState({ cancelInvoiceDialogOpen: false, selectedInvoice: null })}>
                            <DialogTitle>Cancel Invoice</DialogTitle>
                            <DialogContent>
                                <Typography variant="body2" sx={{ mb: 2 }}>
                                    Are you sure you want to cancel this invoice? This action requires a reason.
                                </Typography>
                                <TextField
                                    fullWidth
                                    multiline
                                    rows={3}
                                    label="Cancellation Reason (Required)"
                                    required
                                    inputRef={ref => this.cancellationReasonInput = ref}
                                />
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => this.setState({ cancelInvoiceDialogOpen: false, selectedInvoice: null })}>No, Keep Invoice</Button>
                                <Button onClick={() => {
                                    if (!this.cancellationReasonInput?.value?.trim()) {
                                        toast.error('Please provide a cancellation reason');
                                        return;
                                    }
                                    this.cancelInvoice(this.state.selectedInvoice?.Id, this.cancellationReasonInput.value);
                                }} variant="contained" color="error">Yes, Cancel Invoice</Button>
                            </DialogActions>
                        </Dialog>

                        {/* US 6.8: Reverse Status Dialog */}
                        <Dialog open={this.state.reverseStatusDialogOpen} onClose={() => this.setState({ reverseStatusDialogOpen: false, selectedInvoice: null })}>
                            <DialogTitle>Reverse Invoice Status</DialogTitle>
                            <DialogContent>
                                <Typography variant="body2" sx={{ mb: 2 }}>
                                    Current Status: <strong>{this.state.selectedInvoice?.InvoiceStatus}</strong>
                                </Typography>
                                <FormControl fullWidth sx={{ mt: 2 }}>
                                    <InputLabel>New Status</InputLabel>
                                    <Select
                                        value={this.state.newStatus || ''}
                                        onChange={(e) => this.setState({ newStatus: e.target.value })}
                                        label="New Status"
                                        inputRef={ref => this.newStatusInput = ref}
                                    >
                                        <MenuItem value="New">New</MenuItem>
                                        <MenuItem value="Issued">Issued</MenuItem>
                                    </Select>
                                </FormControl>
                                <TextField
                                    fullWidth
                                    multiline
                                    rows={3}
                                    label="Reason for Reversal (Required)"
                                    required
                                    sx={{ mt: 2 }}
                                    inputRef={ref => this.reversalReasonInput = ref}
                                />
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => this.setState({ reverseStatusDialogOpen: false, selectedInvoice: null, newStatus: null })}>Cancel</Button>
                                <Button onClick={() => {
                                    if (!this.reversalReasonInput?.value?.trim()) {
                                        toast.error('Please provide a reason for reversal');
                                        return;
                                    }
                                    this.reverseInvoiceStatus(this.state.selectedInvoice?.Id, this.newStatusInput?.value, this.reversalReasonInput.value);
                                }} variant="contained" color="warning">Reverse Status</Button>
                            </DialogActions>
                        </Dialog>
                                                
                    </MainContentContainer>
                </BodyContainer>
            </AppContainer>
        );
    }
}

export default (withRouter(Invoices));